import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import AnchorButton from '@adsk/bim360-matrix-react-anchor-button';
import { ThemeConsumer } from '@adsk/bim360-matrix-react-helpers/es/theme';

import './_MenuItem.scss';

/**
 * MenuItem - An menu item based on li element that should be used as a child of a ul element. The ul element should have
 * list-style: "none" for better look
 */
export default class MenuItem extends Component {
  /**
   * constructor
   */
  constructor() {
    super();
    this._handleOnMenuItemClick = this._handleOnMenuItemClick.bind(this);
  }

  /**
   * onMenuItemClick
   */
  _handleOnMenuItemClick(event) {
    event.stopPropagation();
    event.preventDefault();
    this.props.onClick(this.props.eventKey);
  }

  /**
   * render
   */
  render() {
    return (
      <li>
        <ThemeConsumer>
          {({ theme }) => (
            <AnchorButton
              className={classNames('MenuItem__link', `MenuItem__link--${theme}`, {
                'MenuItem__link--disabled': this.props.disabled
              })}
              disabled={this.props.disabled}
              onClick={this._handleOnMenuItemClick}
            >
              {this.props.children}
            </AnchorButton>
          )}
        </ThemeConsumer>
      </li>
    );
  }
}

MenuItem.propTypes = {
  /**
   * An identifier of the item
   */
  eventKey: PropTypes.string.isRequired,
  /**
   * Handle for item click event
   */
  onClick: PropTypes.func,
  /**
   * The text or node of the item
   */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /**
   * Determines if the item should be disabled
   */
  disabled: PropTypes.bool
};
